import { ref, reactive, toRefs } from 'vue';
import axios from 'axios';

const complex = reactive({
  complexId: '',
  complexDetails: {
    name: '',
    complexCode: '',
    numberOfUnits: '',
    cityName: '',
    addressName: '',
    addressName2: '',
    stateCode: '',
    zipCode: '',
    contactName: '',
    contactPhone: '',
    contactEmail: '',
    retired: false,
    notes: '',
    blobGeneralId: null,
    amenityCodes: [],
  },
});

const complexes = reactive([]);
const complexName = ref();
const currentComplexId = ref();

export default function useComplex() {
  const preProcessComplex = () => {
    complex.complexDetails.numberOfUnits = Number(complex.complexDetails.numberOfUnits);
  };

  const resetCurrentComplexId = async () => {
    currentComplexId.value = null;
    complex.complexDetails = {
      name: '',
      complexCode: '',
      numberOfUnits: '',
      cityName: '',
      addressName: '',
      addressName2: '',
      stateCode: '',
      zipCode: '',
      contactName: '',
      contactPhone: '',
      contactEmail: '',
      retired: false,
      notes: '',
      blobGeneralId: null,
      amenityCodes: [],
    };
  };

  const createComplex = async () => {
    try {
      preProcessComplex();
      const result = await axios.post(`${process.env.VUE_APP_HOUSING_SERVICE_URL}/api/complexes`, complex.complexDetails);

      return result;
    } catch (error) {
      console.log(error);
      return error.response;
    }
  };

  const fetchComplexes = async () => {
    try {
      const url = `${process.env.VUE_APP_HOUSING_SERVICE_URL}/api/Complexes`;
      const response = await axios.get(url);
      const { data } = response;
      complexes.value = data;
    } catch (error) {
      console.log(error);
    }
  };

  const fetchComplex = async (fetchedId, isShowingRetired = false,
    assignToComplexDetails = true) => {
    try {
      if (fetchedId === undefined || fetchedId === null) {
        return null;
      }
      const url = `${process.env.VUE_APP_HOUSING_SERVICE_URL}/api/complexes/${fetchedId}`;
      const response = await axios.get(url, {
        params: {
          isShowingRetired,
        },
      });
      const { data } = response;
      if (assignToComplexDetails && data) {
        complex.complexDetails = data;
      }

      return data;
    } catch (error) {
      console.log(error);
      return error.response;
    }
  };

  const fetchComplexCodesAndNames = async () => {
    try {
      const url = `${process.env.VUE_APP_HOUSING_SERVICE_URL}/api/complexes/getComplexCodesAndNames`;
      const response = await axios.get(url);
      const { data } = response;
      if (data !== undefined || data !== null) {
        return data.data;
      }
    } catch (error) {
      console.log(error);
    }

    return null;
  };

  const fetchComplexName = async (fetchedId) => {
    try {
      await fetchComplex(fetchedId);
      complexName.value = complex.complexDetails.name;
    } catch (error) {
      console.log(error);
    }
  };

  const updateComplex = async (updateId) => {
    try {
      const result = await axios.put(`${process.env.VUE_APP_HOUSING_SERVICE_URL}/api/complexes/${updateId}`, complex.complexDetails);

      return result;
    } catch (error) {
      console.log(error);
      return error.response;
    }
  };

  return {
    ...toRefs(complex),
    ...toRefs(complexes),
    complexName,
    createComplex,
    currentComplexId,
    fetchComplex,
    fetchComplexCodesAndNames,
    fetchComplexes,
    fetchComplexName,
    resetCurrentComplexId,
    updateComplex,
  };
}
